import { Observable } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { ref, Storage, uploadBytes } from '@angular/fire/storage';
import { select, Store } from '@ngrx/store';
import { selectCurrentUserCompanyId } from '../../current-user/store/current-user.selectors';
import { filter, switchMap, take } from 'rxjs/operators';
import { inputIsNotNullOrUndefined } from '../../data-access/input-is-not-null-or-undefined';
import { UploadResult } from '@firebase/storage';
import { buildDocumentStoragePath } from '../../utils/document-storage-path';

export interface UploadPayload {
  file: File,
  fileName: string,
  documentId: string,
}

@Injectable({
  providedIn: 'root',
})
export class UploadDocumentService {
  private readonly storage = inject(Storage);
  private readonly store = inject(Store);

  upload(payload: UploadPayload): Observable<UploadResult> {
    return this.store.pipe(select(selectCurrentUserCompanyId)).pipe(
      filter(inputIsNotNullOrUndefined),
      take(1),
      switchMap(companyId => {
        const fileRef = ref(this.storage, buildDocumentStoragePath(companyId, payload.documentId));
        return uploadBytes(fileRef, payload.file, {
          contentDisposition: `attachment; filename="${ payload.fileName }"`,
        });
      }),
    );
  }
}
